<template>
  <div class="edit-image">
    <div v-for="part in parts" :key="part.table_id">
      <div v-if="part.table_id === current.tableId">
        <!-- 画像パーツ編集 -->
        <image-part-edit
          :current="current"
          :part="part"
          :sectionId="sectionId"
          :partsContainerId="partsContainerId"
          :partsContainerType="partsContainerType"
          :partsContainerStyles="partsContainerStyles"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ImagePartEdit from '@/components/Content/Palette/EditPartDesign/Editor/Image/ImageEdit'

export default {
  props: [
    'current',
    'parts',
    'sectionId',
    'partsContainerId',
    'partsContainerType',
    'partsContainerStyles',
  ],
  components: {
    ImagePartEdit,
  }
}
</script>
